<div class="modify-search">
  @if (buttonType === 'link') {
    <div class="link-style" (click)="toggleModal()">
      @if (modify) {
        <span i18n="@@modifysearch_modificar_busqueda">Modificar búsqueda</span>
      } @else {
        <span i18n="@@modifysearch_elegir_fechas">Elegir fechas</span>
      }
    </div>
  }
  @if (buttonType === 'button') {
    <button
      mb-button
      mb-button-fullwidth
      (click)="toggleModal()"
      variant="principal"
      color="primary"
    >
      @if (modify) {
        <span i18n="@@modifysearch_modificar_busqueda">Modificar búsqueda</span>
      } @else {
        <span i18n="@@modifysearch_elegir_fechas">Elegir fechas</span>
      }
    </button>
  }
</div>
